export const FRAMEWORKS = [
  "Holland's RIASEC Interest Model", "Big Five / Five-Factor Model", "HEXACO Personality Model",
  "Jungian Type Theory (MBTI lineage)", "Strengths-Based Development (CliftonStrengths lineage)",
  "VIA Character Strengths", "DISC Behavioural Styles", "Hogan-style Leadership Derailers",
  "Kolbe / Thomas-Kilmann / Belbin Team-Role Theory", "Schein's Career Anchors",
  "O*NET, Strong Interest & CareerOneStop Occupational Data", "Raven's / Wonderlic / 16PF Cognitive Traditions",
];

export const BLUEPRINT_GROUPS = [
  { label: "Career Interests (RIASEC)", count: 6 },
  { label: "Core Personality", count: 6 },
  { label: "Cognitive & Professional Aptitude", count: 6 },
  { label: "Career Values & Motivators", count: 6 },
  { label: "Professional Strengths & Work Style", count: 8 },
  { label: "Interpersonal & Leadership Potential", count: 6 },
  { label: "Entrepreneurship & Innovation", count: 2 },
];

export const ITEM_FORMATS = [
  { name: "Likert Self-Report", detail: "How true a statement feels for you, on a 5-point scale." },
  { name: "Behavioural-Frequency", detail: "How often you actually do something, not just how you feel about it." },
  { name: "Reverse-Keyed", detail: "The same trait asked in the opposite direction, to catch inattentive answering." },
  { name: "Forced-Choice Aptitude", detail: "Objective numerical, verbal, spatial and logical reasoning items." },
  { name: "Situational Judgment (SJT)", detail: "Realistic workplace scenarios where you pick your most likely response." },
  { name: "Trade-Off / Ranking", detail: "Choosing between two genuinely appealing options to reveal true priorities." },
];

export const PROOF_STAGES = [
  { step: "01", name: "Define Constructs", detail: "Every dimension is grounded in a named, published psychological framework before a single item is written.", status: "Complete" },
  { step: "02", name: "Build the Item Bank", detail: "A wide pool of candidate items is drafted for every dimension, deliberately more than the final form needs.", status: "Complete" },
  { step: "03", name: "Expert & Cognitive Review", detail: "Items are reviewed for clarity, cultural neutrality and construct fit, then refined into the production set.", status: "In Progress" },
  { step: "04", name: "Large-Scale Piloting", detail: "The refined form is administered to a broad, diverse sample before any scores are treated as final.", status: "Not Started Yet" },
  { step: "05", name: "Factor Analysis", detail: "Statistical modelling confirms that items genuinely group the way the underlying theory predicts.", status: "Not Started Yet" },
  { step: "06", name: "Reliability & Validity Studies", detail: "Internal consistency and real-world predictive value are measured, not assumed.", status: "Not Started Yet" },
  { step: "07", name: "Fairness & Norm Studies", detail: "Results are checked across gender, language and background so no group is systematically disadvantaged.", status: "Not Started Yet" },
  { step: "08", name: "Launch, Monitor & Recalibrate", detail: "Live data continues to refine the model over time — this is a living instrument, not a one-time build.", status: "Not Started Yet" },
];

export const DELIVERABLE_SECTIONS = [
  "Executive Career Profile & Assessment Confidence", "Career Interests (RIASEC) Archetype Breakdown",
  "Core Personality & Career Values Profiles", "Cognitive & Professional Aptitude Snapshot",
  "Interpersonal, Leadership & Entrepreneurial Potential", "Ranked Career Matches Across 800+ Occupations",
  "Hidden Possibilities & Development Priorities", "Situational Judgment Response Annex",
];

export const SCIENCE_STATS = [
  { value: "40", label: "Psychometric Dimensions" },
  { value: "12+", label: "Established Frameworks Synthesised" },
  { value: "252", label: "Production Assessment Items" },
  { value: "8", label: "Stage Validation Pipeline" },
  { value: "800+", label: "Occupations Mapped (O*NET)" },
];

export const APTITUDE_TEST_TYPES = [
  { name: "Numerical Reasoning", detail: "Solving practical maths and logic problems with numbers." },
  { name: "Vocabulary", detail: "Synonyms, antonyms and word relationships." },
  { name: "Inductive Reasoning", detail: "Spotting the underlying rule in a pattern or sequence." },
  { name: "Spatial Visualization", detail: "Mentally rotating and manipulating visual patterns." },
  { name: "Sequential Reasoning", detail: "Putting the steps of a process into the correct order." },
  { name: "Visual Comparison Speed", detail: "Spotting matching vs. differing details quickly and accurately." },
  { name: "Idea Generation", detail: "Generating original ideas fluently under time pressure." },
  { name: "Work Approach Style", detail: "Your natural working-style preferences — no right or wrong answers." },
];
